import {
  MODAL_CLOSE,
  MODAL_OPEN
} from '../constants/Constants';

export const openModal = (modalId, data) => ({ type: MODAL_OPEN, payload: { id: modalId, ...data } });
export const closeModal = (modalId, data) => ({ type: MODAL_CLOSE, payload: { id: modalId, ...data } });



// WEBPACK FOOTER //
// ./src/actions/ModalActions.js